import PropTypes from 'prop-types';
// material
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
// components
import ItemPrice from '../common/ItemPrice';
import ItemVoucher from '../common/ItemVoucher';

const RootStyle = styled(ListItem)(({ theme }) => ({
  borderRadius: '16px',
  backgroundColor: theme.palette.grey[500_16],
  marginBottom: theme.spacing(2),
  padding: theme.spacing(3)
}));

const SectionStyle = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  marginBottom: theme.spacing(1)
}));

OrderItem.propTypes = {
  item: PropTypes.object
};

export default function OrderItem({ item }) {
  return (
    <RootStyle alignItems="flex-start">
      <ListItemText>
        <Box mr={2} flexGrow={1}>
          <ListItemText
            primary={
              <>
                <Typography component="span">{item.ticket.name}</Typography>
                <Typography component="span" color="textSecondary">
                  {item.ticket.rule.name ? ` | ${item.ticket.rule.name}` : ''}
                </Typography>
                <SectionStyle>
                  {`${item.ticket.seatsio.labels.parent}-${item.ticket.seatsio.labels.own} ${item.section.name}`}
                </SectionStyle>
              </>
            }
          />
        </Box>
        <Box display="flex">
          <Box flexGrow={1}>
            <ItemPrice ticket={item.ticket} />
          </Box>
        </Box>
        {item.ticket.voucher.isApplicable && item.ticket.voucher.code && (
          <ItemVoucher item={item} />
        )}
      </ListItemText>
    </RootStyle>
  );
}
